import Quill from 'quill';
import { useEffect } from 'react';

interface QuillEditorRef {
  getQuill?: () => Quill;
}

export function useQuillMessageBindings(
  editorRef: React.RefObject<QuillEditorRef>,
  submitButtonRef: React.RefObject<HTMLButtonElement>,
): void {
  useEffect(() => {
    const initializeQuillBindings = (): void => {
      const quill: Quill | undefined = editorRef.current?.getQuill?.();
      if (!quill) {
        setTimeout(initializeQuillBindings, 100);
        return;
      }

      // Remove default Enter bindings to avoid duplication
      quill.keyboard.bindings.Enter = [];

      // Enter (submit)
      quill.keyboard.addBinding(
        {
          key: 13, // Enter
          shiftKey: false,
        },
        () => {
          submitButtonRef.current?.click();
          return false;
        },
      );

      // Shift+Enter (newline or list continuation)
      quill.keyboard.addBinding(
        {
          key: 13,
          shiftKey: true,
        },
        (range: { index: number }) => {
          const format = quill.getFormat(range.index);
          if (format.list) {
            quill.insertText(range.index, '\n', 'list', format.list, 'user');
          } else {
            quill.insertText(range.index, '\n', 'user');
          }
          quill.setSelection(range.index + 1, 0, 'user');
          return false;
        },
      );
    };

    initializeQuillBindings();
  }, [editorRef, submitButtonRef]);
}
